<template>
  <div class="main">
    <Header
      :show="true"
      title="业务"
      left=""
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        class="menu-wrap"
      >
        <van-cell
          v-if="
            item.permission.length ? checkPermission(item.permission) : true
          "
          class="menu-item-wrap"
          center
        >
          <template #title>
            <div class="menu-item-inner">
              <img
                class="menu-item-icon"
                :src="imageSrc.gridHeaderLeft"
              >
              <div class="menu-item-title">
                {{ item.title }}
              </div>
            </div>
          </template>
        </van-cell>
        <van-grid :column-num="4">
          <van-grid-item
            v-for="btn in item.children"
            v-show="
              btn.permission.length ? checkPermission(btn.permission) : true
            "
            :key="btn.path"
            :icon="btn.icon"
            :text="btn.title"
            :to="btn.path"
          />
        </van-grid>
      </div>
      <div class="menu-wrap">
        <van-cell
          class="menu-item-wrap"
          center
        >
          <template #title>
            <div class="menu-item-inner">
              <img
                class="menu-item-icon"
                :src="imageSrc.gridHeaderLeft"
              >
              <div class="menu-item-title">
                其他
              </div>
            </div>
          </template>
        </van-cell>
        <van-grid :column-num="4">
          <van-grid-item
            :icon="imageSrc.iconWoDeCaoZuoShouCe"
            text="操作手册"
            @click="handleClickManualDownload"
          />
          <van-grid-item
            :icon="imageSrc.iconWoDeGuanYuWoMen"
            text="关于我们"
            @click="handleClickCellAboutUs"
          />
          <van-grid-item
            :icon="imageSrc.iconWoDeTuiChuDengLu"
            text="退出登录"
            @click="handleClickCellExit"
          />
          <van-uploader
            class="menu-grid-item"
            :max-count="1"
            :deletable="false"
            :before-read="beforeRead"
            :after-read="afterRead"
          >
            <van-grid-item
              :icon="imageSrc.iconWoDeYongHuTouXiang"
              text="用户头像"
              @click="handleClickUpdateAvatar"
            />
          </van-uploader>
        </van-grid>
      </div>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { mapGetters } from "vuex";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import { info } from "@/config/config.json";
import { logout as userLogout } from "@/api/user.js";
import { createWhiteOne } from "@/api/staff.js";

const imageSrc = {
  gridHeaderLeft: require("@/assets/svg/gridHeaderLeft.svg"),
  iconYeWuYueYuShenHe: require("@/assets/svg/iconYeWuYueYuShenHe.svg"),
  iconYeWuShuiFenJianCe: require("@/assets/svg/iconYeWuShuiFenJianCe.svg"),
  iconYeWuFenLiaoJianCe: require("@/assets/svg/iconYeWuFenLiaoJianCe.svg"),
  iconYeWuHuoChePaiDui: require("@/assets/svg/iconYeWuHuoChePaiDui.svg"),
  iconKongZhiRenLianZhaJi: require("@/assets/svg/iconKongZhiRenLianZhaJi.svg"),
  iconKongZhiCheLiangDaoZha: require("@/assets/svg/iconKongZhiCheLiangDaoZha.svg"),
  iconKongZhiDiBangDaoZha: require("@/assets/svg/iconKongZhiDiBangDaoZha.svg"),
  iconKongZhiXieLiaoGuanKou: require("@/assets/svg/iconKongZhiXieLiaoGuanKou.svg"),
  iconLiShiRenLianZhaJi: require("@/assets/svg/iconLiShiRenLianZhaJi.svg"),
  iconLiShiCheLiangDaoZha: require("@/assets/svg/iconLiShiCheLiangDaoZha.svg"),
  iconLiShiYuanLiaoDaoZha: require("@/assets/svg/iconLiShiYuanLiaoDaoZha.svg"),
  iconLiShiWuRenGuoBang: require("@/assets/svg/iconLiShiWuRenGuoBang.svg"),
  iconLiShiWuLiaoPanDian: require("@/assets/svg/iconLiShiWuLiaoPanDian.svg"),
  iconLiShiGuanKouXieLiao: require("@/assets/svg/iconLiShiGuanKouXieLiao.svg"),
  iconLiShiLiaoCangXieLiao: require("@/assets/svg/iconLiShiLiaoCangXieLiao.svg"),
  iconLiShiShangTongZhuangChe: require("@/assets/svg/iconLiShiShangTongZhuangChe.svg"),
  iconGongChengShengChanKaiGuan: require("@/assets/svg/iconGongChengShengChanKaiGuan.svg"),
  iconGongChengYuYueShenHe: require("@/assets/svg/iconGongChengYuYueShenHe.svg"),
  iconGongChengBanGongDaoZha: require("@/assets/svg/iconGongChengBanGongDaoZha.svg"),
  iconGongChengXiaoXiTuiSong: require("@/assets/svg/iconGongChengXiaoXiTuiSong.svg"),
  iconGongChengZhuangCheXian: require("@/assets/svg/iconGongChengZhuangCheXian.svg"),
  iconGongChengXieLiaoGuanKou: require("@/assets/svg/iconGongChengXieLiaoGuanKou.svg"),
  iconGongChengGuLiaoCheShu: require("@/assets/svg/iconGongChengGuLiaoCheShu.svg"),
  iconXiTongYongHuLieBiao: require("@/assets/svg/iconXiTongYongHuLieBiao.svg"),
  iconXiTongBuMenLieBiao: require("@/assets/svg/iconXiTongBuMenLieBiao.svg"),
  iconXiTongJueSeLieBiao: require("@/assets/svg/iconXiTongJueSeLieBiao.svg"),
  iconXiTongHuoCheLieBiao: require("@/assets/svg/iconXiTongHuoCheLieBiao.svg"),
  iconXiTongGongYingShangLieBiao: require("@/assets/svg/iconXiTongGongYingShangLieBiao.svg"),
  iconXiTongChanPinLieBiao: require("@/assets/svg/iconXiTongChanPinLieBiao.svg"),
  iconXiTongWuLiaoLieBiao: require("@/assets/svg/iconXiTongWuLiaoLieBiao.svg"),
  iconWoDeXiuGaiMiMa: require("@/assets/svg/iconWoDeXiuGaiMiMa.svg"),
  iconWoDeCaoZuoShouCe: require("@/assets/svg/iconWoDeCaoZuoShouCe.svg"),
  iconWoDeYunXingRiZhi: require("@/assets/svg/iconWoDeYunXingRiZhi.svg"),
  iconWoDeGuanYuWoMen: require("@/assets/svg/iconWoDeGuanYuWoMen.svg"),
  iconWoDeTuiChuDengLu: require("@/assets/svg/iconWoDeTuiChuDengLu.svg"),
  iconWoDeYongHuTouXiang: require("@/assets/jpg/iconWoDeYongHuTouXiang.jpg"),
  iconJiaYouShenQing: require("@/assets/svg/iconJiaYouShenQing.svg"),
  iconShenHeJiaYouShenQing: require("@/assets/svg/iconShenHeJiaYouShenQing.svg"),
  iconJiaYouBaoBiao: require("@/assets/svg/iconJiaYouBaoBiao.svg"),
  iconJiaYouJiLu: require("@/assets/svg/iconJiaYouJiLu.svg"),
  iconCheLiangGuanLi: require("@/assets/svg/iconCheLiangGuanLi.svg"),
  iconGuoBangJianCe: require("@/assets/svg/iconGuoBangJianCe.svg"),
  iconZiDianLieBiao: require("@/assets/svg/iconZiDianLieBiao.svg"),
  iconFaHuoRenWu: require("@/assets/svg/iconFaHuoRenWu.svg"),
  iconTuiTongJiLu: require("@/assets/svg/iconTuiTongJiLu.svg"),
  iconGaoJingChuLi: require("@/assets/svg/iconGaoJingChuLi.svg"),
  iconKuCunChaXun: require("@/assets/svg/iconKuCunChaXun.svg"),
};

const businessMenu = [
  {
    title: "审核业务",
    permission: [],
    children: [
      {
        title: "人员预约审核",
        icon: imageSrc.iconYeWuYueYuShenHe,
        permission: [11],
        path: "/service/business/verify",
      },
      {
        title: "车辆预约审核",
        icon: imageSrc.iconYeWuYueYuShenHe,
        permission: [14],
        path: "/service/business/verify-car",
      },
      {
        title: "加油申请审核",
        icon: imageSrc.iconShenHeJiaYouShenQing,
        permission: [428],
        path: "/service/business/vehicle-apply",
      },
      {
        title: "加油申请",
        icon: imageSrc.iconJiaYouShenQing,
        permission: [421],
        path: "/service/business/vehicle",
      },
      {
        title: "出库领用申请",
        icon: imageSrc.iconJiaYouShenQing,
        permission: [421],
        path: "/service/business/item-receipt",
      },
    ],
  },
  {
    title: "检测业务",
    permission: [],
    children: [
      {
        title: "过磅检测",
        icon: imageSrc.iconGuoBangJianCe,
        permission: [491],
        path: "/service/business/owdr",
      },
      {
        title: "粉料检测",
        icon: imageSrc.iconYeWuFenLiaoJianCe,
        permission: [31],
        path: "/service/business/material",
      },
    ],
  },
  {
    title: "发货业务",
    permission: [],
    children: [
      {
        title: "发货处理",
        icon: imageSrc.iconFaHuoRenWu,
        permission: [511],
        path: "/service/business/ship-record",
      },
      {
        title: "退砼处理",
        icon: imageSrc.iconTuiTongJiLu,
        permission: [501],
        path: "/service/business/return-concrete",
      },
      {
        title: "装车排队",
        icon: imageSrc.iconYeWuHuoChePaiDui,
        permission: [41],
        path: "/service/business/queue",
      },
      {
        title: "卸料排队",
        icon: imageSrc.iconYeWuHuoChePaiDui,
        permission: [531],
        path: "/service/business/unloading-queue",
      },
    ],
  },
  {
    title: "其他业务",
    permission: [],
    children: [
      {
        title: "库存盘点",
        icon: imageSrc.iconGongChengXieLiaoGuanKou,
        permission: [131],
        path: "/service/project/port",
      },
      {
        title: "告警处理",
        icon: imageSrc.iconGaoJingChuLi,
        permission: [451],
        path: "/service/business/warning",
      },
    ],
  },
  {
    title: "设备控制",
    permission: [],
    children: [
      {
        title: "人脸闸机",
        icon: imageSrc.iconKongZhiRenLianZhaJi,
        permission: [51],
        path: "/service/control/face",
      },
      {
        title: "车辆道闸",
        icon: imageSrc.iconKongZhiCheLiangDaoZha,
        permission: [311],
        path: "/service/control/car",
      },
      {
        title: "地磅道闸",
        icon: imageSrc.iconKongZhiDiBangDaoZha,
        permission: [251],
        path: "/service/control/weigh",
      },
      {
        title: "卸料罐口",
        icon: imageSrc.iconKongZhiXieLiaoGuanKou,
        permission: [61],
        path: "/service/control/port",
      },
    ],
  },
];

const historyMenu = [
  {
    title: "进出查询",
    permission: [],
    children: [
      {
        title: "人员出入记录",
        icon: imageSrc.iconLiShiRenLianZhaJi,
        permission: [71],
        path: "/service/history/face",
      },
      // {
      //   title: "小车出入记录",
      //   icon: imageSrc.iconLiShiCheLiangDaoZha,
      //   permission: [81],
      //   path: "/service/history/car",
      // },
      {
        title: "大车出入记录",
        icon: imageSrc.iconLiShiCheLiangDaoZha,
        permission: [81],
        path: "/service/history/car",
      },
    ],
  },
  {
    title: "原料查询",
    permission: [],
    children: [
      {
        title: "过磅记录",
        icon: imageSrc.iconLiShiWuRenGuoBang,
        permission: [91],
        path: "/service/history/weigh",
      },
      {
        title: "原料入库",
        icon: imageSrc.iconLiShiGuanKouXieLiao,
        permission: [261],
        path: "/service/history/port",
      },
      {
        title: "骨料卸料",
        icon: imageSrc.iconLiShiLiaoCangXieLiao,
        permission: [301],
        path: "/service/history/store",
      },
      {
        title: "加油记录",
        icon: imageSrc.iconJiaYouJiLu,
        permission: [441],
        path: "/service/history/refuel",
      },
      {
        title: "加油报表",
        icon: imageSrc.iconJiaYouBaoBiao,
        permission: [431],
        path: "/service/history/refuel-report",
      },
      {
        title: "库存查询",
        icon: imageSrc.iconKuCunChaXun,
        permission: [333],
        path: "/service/history/stockcur",
      },
      {
        title: "燃油入库记录",
        icon: imageSrc.iconJiaYouJiLu,
        permission: [481],
        path: "/service/history/oil-in-stock",
      },
      // {
      //   title: "柴油入库",
      //   icon: imageSrc.iconYeWuYueYuShenHe,
      //   permission: [11],
      //   path: "/service/business/verify",
      // },
    ],
  },
  {
    title: "发货查询",
    permission: [],
    children: [
      {
        title: "发货记录",
        icon: imageSrc.iconFaHuoRenWu,
        permission: [511],
        path: "/service/history/ship-record",
      },
      {
        title: "退砼记录",
        icon: imageSrc.iconTuiTongJiLu,
        permission: [501],
        path: "/service/history/return-concrete",
      },
      // {
      //   title: "商砼装车",
      //   icon: imageSrc.iconLiShiShangTongZhuangChe,
      //   permission: [281],
      //   path: "/service/history/line",
      // },
    ],
  },
  {
    title: "系统查询",
    permission: [],
    children: [
      {
        title: "盘点记录",
        icon: imageSrc.iconLiShiWuLiaoPanDian,
        permission: [291],
        path: "/service/history/material",
      },
      {
        title: "系统日志",
        icon: imageSrc.iconWoDeYunXingRiZhi,
        permission: [221],
        path: "/service/user/log",
      },
    ],
  },
];

const systemMenu = [
  {
    title: "基础信息",
    permission: [],
    children: [
      {
        title: "部门信息",
        icon: imageSrc.iconXiTongBuMenLieBiao,
        permission: [151],
        path: "/service/system/department",
      },
      {
        title: "角色信息",
        icon: imageSrc.iconXiTongJueSeLieBiao,
        permission: [161],
        path: "/service/system/role",
      },
      {
        title: "用户信息",
        icon: imageSrc.iconXiTongYongHuLieBiao,
        permission: [141],
        path: "/service/system/staff",
      },
      {
        title: "物料信息",
        icon: imageSrc.iconXiTongWuLiaoLieBiao,
        permission: [201],
        path: "/service/system/material",
      },
      {
        title: "员工车辆信息",
        icon: imageSrc.iconXiTongHuoCheLieBiao,
        permission: [171],
        path: "/service/system/truck",
      },
      {
        title: "商砼车辆信息",
        icon: imageSrc.iconCheLiangGuanLi,
        permission: [401],
        path: "/service/system/vehicle",
      },
      {
        title: "供应商信息",
        icon: imageSrc.iconXiTongGongYingShangLieBiao,
        permission: [181],
        path: "/service/system/supplier",
      },
      {
        title: "产品信息",
        icon: imageSrc.iconXiTongChanPinLieBiao,
        permission: [191],
        path: "/service/system/product",
      },
    ],
  },
  {
    title: "配置信息",
    permission: [],
    children: [
      {
        title: "生产开关",
        icon: imageSrc.iconGongChengShengChanKaiGuan,
        permission: [401],
        path: "/service/system/dict",
      },
      {
        title: "消息推送",
        icon: imageSrc.iconGongChengXiaoXiTuiSong,
        permission: [111],
        path: "/service/project/message",
      },
      {
        title: "骨料车数",
        icon: imageSrc.iconGongChengGuLiaoCheShu,
        permission: [271],
        path: "/service/project/number",
      },
      // {
      //   title: "定时任务",
      //   icon: imageSrc.iconYeWuYueYuShenHe,
      //   permission: [11],
      //   path: "/service/business/verify",
      // },
      {
        title: "办公道闸",
        icon: imageSrc.iconGongChengBanGongDaoZha,
        permission: [321],
        path: "/service/project/car",
      },
    ],
  },
  {
    title: "我的设置",
    permission: [],
    children: [
      {
        title: "修改密码",
        icon: imageSrc.iconWoDeXiuGaiMiMa,
        permission: [],
        path: "/service/user/password",
      },
      {
        title: "加油申请说明",
        icon: imageSrc.iconWoDeCaoZuoShouCe,
        permission: [],
        path: "/service/manual/apply",
      },
      {
        title: "加油管理说明",
        icon: imageSrc.iconWoDeCaoZuoShouCe,
        permission: [],
        path: "/service/manual/manager",
      },
      {
        title: "加油管理说明",
        icon: imageSrc.iconWoDeCaoZuoShouCe,
        permission: [],
        path: "/service/manual/system",
      },
    ],
  },
];

export default {
  name: "Service",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      imageSrc,
      loading: false,
      listQuery: {
        serial: null,
        username: "",
        name: "永固万年青",
        phone: "",
        discribe: "心怀信仰，沐浴阳光",
        image: [require("@/assets/user/header.jpg")],
        avatar: require("@/assets/user/header.jpg"),
        gate: 3,
        file: null,
        reason: "员工绿色通道",
        startDate: new Date().getTime(),
        endDate: new Date().getTime(),
        validEnable: 1,
      },
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      baseUrl: "",
      manualUrl: info["manual-address"],
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
      username: "user/username",
      name: "user/name",
      phone: "user/phone",
      discribe: "user/discribe",
      avatar: "user/avatar",
    }),
    menuList() {
      const list = [...businessMenu, ...historyMenu, ...systemMenu].reduce(
        (array, current) => {
          const { permission, children, title } = current;

          const newPermission = [
            ...new Set([
              ...permission,
              ...children.reduce(
                (array, item) => array.concat(item.permission),
                []
              ),
            ]),
          ];

          array.push({ title, children, permission: newPermission });
          return array;
        },
        []
      );
      console.log("list", list);
      return list;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {
    const url = window.location.href;
    this.baseUrl = "";
    const avatar = this.baseUrl + this.avatar;
    console.log(avatar);
    this.listQuery.image = [];
    if (this.avatar !== "" && this.avatar !== null) {
      this.listQuery.image.push(avatar);
      this.listQuery.avatar = avatar;
      this.imageSrc.iconWoDeYongHuTouXiang = avatar;
    }
    const userid = this.userid;
    if (userid !== null) {
      this.listQuery.serial = userid;
    }
    const username = this.username;
    if (username !== "" && username !== null) {
      this.listQuery.username = username;
    }
    const name = this.name;
    if (name !== "" && name !== null) {
      this.listQuery.name = name;
    }
    const phone = this.phone;
    if (phone !== "" && phone !== null) {
      this.listQuery.phone = phone;
    }
    const discribe = this.discribe;
    if (discribe !== "" && discribe !== null) {
      this.listQuery.discribe = discribe;
    }
    console.log(this.listQuery);
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("dashboard-left");
    },
    handleClickRight() {
      console.log("dashboard-right");
    },
    handleClickManualDownload() {
      window.open(this.manualUrl, "_blank");
    },
    handleClickUpdatePassword() {
      this.$router.push({
        path: "/user/password",
        query: {
          username: this.listQuery.username,
        },
      });
    },
    handleClickCellAboutUs() {
      window.open(info["official-site"], "_blank");
    },
    beforeRead(file) {
      const allowType = ["image/png", "image/jpeg"];
      if (!allowType.includes(file.type)) {
        this.$toast("请上传jpg/png格式图片");
        return false;
      }
      return true;
    },
    afterRead(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          this.handleClickUpdateAvatar();
          resolve(file);
        } else {
          const scale = parseFloat(
            1 / (file.file.size / 1024 / 1024 / 0.2)
          ).toFixed(2);
          imageConversion
            .compressAccurately(file.file, {
              size: 180,
              // scale: scale,
              width: 640,
            })
            .then((res) => {
              this.listQuery.file = res;
              this.handleClickUpdateAvatar();
              resolve(res);
            });
        }
      });
    },
    handleClickUpdateAvatar() {
      this.handleClickCreateAvatar();
    },
    handleClickCreateAvatar() {
      let data = new FormData();
      data.append("name", this.listQuery.name);
      data.append("phone", this.listQuery.phone);
      data.append("gate", this.listQuery.gate);
      data.append("image", this.listQuery.file);
      data.append("reason", this.listQuery.reason);
      data.append("startDate", this.listQuery.startDate);
      data.append("endDate", this.listQuery.endDate);
      data.append("validEnable", this.listQuery.validEnable);
      this.loading = true;
      createWhiteOne(data, this.listQuery.serial)
        .then((response) => {
          const { data } = response;
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "添加人脸信息",
            data.message
          );
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          console.error(error);
        });
    },
    handleClickCellExit() {
      Dialog.confirm({
        title: "确认退出登录？",
        message: "再次访问需要重新登录",
      })
        .then(async () => {
          await this.$store.dispatch("user/logout");
          this.$router.push({
            path: "/login",
          });
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "退出登录", "取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// 系统样式修改
.van-cell {
  padding: 1.5vw 3vw;
}
::v-deep .van-cell__label {
  width: 60vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #f8f8f8; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}

.menu-wrap {
  background-color: #fff;

  + .menu-wrap {
    margin-top: 12px;
  }
  .menu-item-wrap {
    &::after {
      display: none;
    }
    .menu-item-inner {
      display: flex;
      align-items: center;
      padding: 5px 0;
      width: 100%;

      .menu-item-icon {
        width: 20px;
        height: 20px;
        margin-right: 1vw;
      }
      .menu-item-title {
        font-size: 1.1em;
      }
    }
  }
}

.menu-grid-item {
  flex-basis: 25%;
  ::v-deep .van-uploader__wrapper {
    width: 100%;
    .van-uploader__input-wrapper {
      width: 100%;
    }
  }
}
</style>
